import { useEffect, useState } from "react";
import { Card, CardContent } from "../../ui/card";
/* import { ChevronRight, icons } from "lucide-react"; */
import DataLoader from "../../../components/loaders/DataLoader";
/* import { useNavigate } from "react-router-dom"; */

interface KpiCardProps {
  title: string;
  value: number;
  delta: string;
  isLoading?: boolean; // add loading prop
  navigateTo?: string;
  icon: React.ReactNode;
}

export function KpiCard({ title, value, isLoading = false, /* navigateTo, */ icon  }: KpiCardProps) {
  const [displayValue, setDisplayValue] = useState<number | null>(null);
  /* const isPositive = delta.trim().startsWith("+"); */
  /* const navigate = useNavigate();  */// ← get navigation function
  

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDisplayValue(value);
    }, 50);
    return () => clearTimeout(timeout);
  }, [value]);

  /* const handleClick = () => {
    if (navigateTo) {
      navigate(navigateTo);
    }
  };
 */
  return (
      <Card className="h-full flex flex-col justify-between">
 {/*        <CardHeader className="uppercase text-sm tracking-[.1em] font-bold p-6 pb-2 flex flex-row items-center">
          {title}
        </CardHeader> */}
        {isLoading ? (
          // Render DataLoader variant inside the card
          <div className="p-6 ">
            <DataLoader variant="kpi" itemCount={1} />
          </div>
        ) : (
          <>
            <CardContent>
          <div className="flex items-center justify-between pb-2">
            <p className="text-sm font-medium text-muted-foreground">
                {title}
              </p>
        <div className="absolute right-4 top-4 dark:text-white flex items-center justify-center group-hover:bg-black/80 dark:group-hover:bg-white/80 group-hover:text-white dark:group-hover:text-black transition-smooth">
          {icon}
        </div>
          </div>
          <div className="text-2xl font-bold">{displayValue}</div>
          {/* <p className="text-sm">
            <span
              className={`${
                isPositive
                  ? "font-bold text-green-600 dark:text-green-400"
                  : "font-bold text-red-600 dark:text-red-400"
              }`}
            >
              {delta}
            </span>{" "}
            vs prev. month
          </p> */}
        </CardContent>
        </>
        )}
      </Card>
   
  );
}
